var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { RestServiceBase } from '@ane/core/lib/services/RestServiceBase';
import { parseError } from '@ane/core/lib/utils/ErrorUtils';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
import { WPSProxyConverter } from '@ane/core/lib/services/WPSProxy';
const apiVersion = '2021-06-09';
let apiVersionForProfilingList = '2021-06-09';
if (EnvironmentService.releaseDSMSdataprofiling()) {
    apiVersionForProfilingList = '2021-11-11';
}
let DataSourceListResource = class DataSourceListResource extends RestServiceBase {
    constructor() {
        super(EnvironmentService.endpoints.dsms, '', parseError);
    }
    async getDataSourceList(workspaceId, search, dataSourceType) {
        let address = `/workspaces/${workspaceId}/DataSources/paging?apiVersion=${apiVersionForProfilingList}`;
        if (!!search) {
            address = `/workspaces/${workspaceId}/DataSources/search?apiVersion=${apiVersionForProfilingList}&query=${search}`;
        }
        if (!!dataSourceType) {
            address = `/workspaces/${workspaceId}/DataSources/search?apiVersion=${apiVersionForProfilingList}&query=${search}&dataSourceType=${dataSourceType}`;
        }
        const result = await this._get(address);
        return result;
    }
    async triggerValidate(workspaceId, dataSourceName) {
        let address = `/workspaces/${workspaceId}/DataSources/${dataSourceName}/validate?apiVersion=${apiVersion}`;
        const result = await this._post({}, address);
        return result;
    }
    async postDataSource(postParams) {
        const address = `/workspaces/${postParams.WorkspaceId}/DataSources?apiVersion=${apiVersion}`;
        const result = await this._post(postParams, address);
        return result;
    }
    async postDuplicateDataSource(postParams) {
        const address = `/workspaces/${postParams.WorkspaceId}/DataSources/Duplicates?apiVersion=${apiVersion}`;
        const result = await this._post(postParams, address);
        return result;
    }
    async putDataSource(postParams, baseOnVersion) {
        const address = undefined === baseOnVersion
            ? `/workspaces/${postParams.WorkspaceId}/DataSources?apiVersion=${apiVersion}`
            : `/workspaces/${postParams.WorkspaceId}/DataSources?apiVersion=${apiVersion}&baseOnVersion=${baseOnVersion}`;
        const result = await this._put(postParams, address);
        return result;
    }
    async cloneDataSource(dataSourceClonePost) {
        const address = `/workspaces/${dataSourceClonePost.workspaceId}/DataSources/${dataSourceClonePost.name}/CloneFrom/${dataSourceClonePost.source}?apiVersion=${apiVersion}`;
        const result = await this._post(dataSourceClonePost, address);
        return result;
    }
    async deleteDataSource(workspaceId, name) {
        const address = `/workspaces/${workspaceId}/DataSources/${name}?apiVersion=${apiVersion}`;
        const result = await this._delete(address);
        return result;
    }
    async getDataSource(workspaceId, name) {
        const address = `/workspaces/${workspaceId}/DataSources/${name}?apiVersion=${apiVersion}`;
        const result = await this._get(address);
        return result;
    }
    async getDataSourceSchema(workspaceId, name) {
        const address = `/workspaces/${workspaceId}/DataSources/${name}/schema?apiVersion=${apiVersion}`;
        const result = await this._get(address);
        return result;
    }
    async getDataSourceHistory(workspaceId, name) {
        let apiVersionForHistory = '2021-11-11';
        const address = `/workspaces/${workspaceId}/DataSources/${name}/history?apiVersion=${apiVersionForHistory}`;
        const result = await this._get(address);
        return result;
    }
    async getDataSourceStatus(workspaceId, name) {
        const address = `/workspaces/${workspaceId}/DataSources/${name}/status-all?apiVersion=${apiVersion}&withDebugInfo=true`;
        const result = await this._get(address);
        return result;
    }
    async getDataSourceAccess(workspaceId, name) {
        const address = `/workspaces/${workspaceId}/DataSources/${name}/Access?apiVersion=${apiVersion}`;
        const result = await this._get(address);
        return result;
    }
    async getDataSourceOverrideList(workspaceId, name) {
        const address = `/workspaces/${workspaceId}/DataSources/${name}/override?apiVersion=${apiVersion}`;
        const result = await this._get(address);
        return result;
    }
    async getSupportedFlightFormats(workspaceId, dataSourceType) {
        const address = `/workspaces/${workspaceId}/supportedFlightFormats?apiVersion=${apiVersion}&dataSourceType=${dataSourceType}`;
        const result = await this._get(address);
        return result;
    }
    async triggerDataProfiling(workspaceId, dataSourceProfiling) {
        const address = `/workspaces/${workspaceId}/dataProfile/postJobSubmitRequest?apiVersion=${apiVersion}`;
        const result = await this._post(dataSourceProfiling, address);
        return result;
    }
};
DataSourceListResource = __decorate([
    WPSProxyConverter()
], DataSourceListResource);
export default new DataSourceListResource();

//# sourceMappingURL=DataSource.resource.js.map
